import React from 'react';
import { string } from 'prop-types';

import Tooltip from 'components/Map/MapComponents/Tooltip';
import TooltipItem from 'components/Map/MapComponents/TooltipItem';
import BatteryIcon from 'components/BatteryIcon';
import DeviceStatusText from 'components/DeviceStatusText';
import trackingDeviceShape from 'propTypes/trackingDeviceShape';

import formatNextUpdate from 'helpers/formatNextUpdate';
import formatLastUpdate from 'helpers/formatLastUpdate';

import styles from './location-tooltip.scss';

export default function LocationTooltip({ locationName, trackingDevice }) {
  const { batteryVoltage, reportInterval, lastUpdate, status } = trackingDevice;
  const isDeviceOnline = status !== 'disconnected';

  return (
    <Tooltip className={styles[`status-${status}`]} offset={[5.75, -45]}>
      <TooltipItem label="status" status={status} isLocation>
        <div className={styles.statusItem}>
          <span className={styles.statusText}>
            <DeviceStatusText status={status} />
          </span>
          <span className={styles.batteryContainer}>
            {isDeviceOnline &&
              <BatteryIcon className={styles.batteryIcon} batteryVoltage={batteryVoltage} />}
          </span>
        </div>
      </TooltipItem>
      <TooltipItem label="location">
        {locationName}
      </TooltipItem>
      {isDeviceOnline
        ? <TooltipItem label="next update">
            {formatNextUpdate(lastUpdate, reportInterval)}
          </TooltipItem>
        : <TooltipItem label="last update">
            {formatLastUpdate(lastUpdate)}
          </TooltipItem>}
    </Tooltip>
  );
}

LocationTooltip.propTypes = {
  trackingDevice: trackingDeviceShape.isRequired,
  locationName: string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Map/MapComponents/LocationTooltip/index.js